/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { Component } from '@appCanvasCommon/component-system/Component';
import { ComponentInterface } from '@appCanvasCommon/interfaces/component.interface';
import { CanvasAngularLand } from '../../../../app-data/interfaces/canvas-angular-land';
import { AbstractApplication } from '@appCanvasCommon/core/AbstractApplication';
import { IExportContext } from '@appCanvasCommon/export/IExportContext';
import { Container } from 'pixi.js-legacy';
import { LayerPaths } from '@appPlanApplication/LayerPaths';
/**
 * This export component hides the root timeline node when the capture is printing the 2nd row and beyond
 * Otherwise the timeline would be copied vertically as the camera scans the plan area.
 */
export class HideTimeline extends Component implements ComponentInterface {
	/**
	 * Invoked for each tile captured. If not first row, disables the timeline so it is not captured in subsequent captures
	 * @param canvasAngularLand
	 * @param application
	 * @param context
	 */
	public onExportTile(
		canvasAngularLand: CanvasAngularLand,
		application: AbstractApplication,
		context: IExportContext
	): void {
		if (context.isFirstRow) {
			return;
		}

		const timelineLayer: Container | null = application.layerManager.getLayer(LayerPaths.UI_TIMELINE_ROOT);
		if (timelineLayer) {
			timelineLayer.visible = false;
		}

		const activeSpaceLayer: Container | null = application.layerManager.getLayer(
			LayerPaths.UI_TIMELINE_ACTIVE_SPACE
		);
		if (activeSpaceLayer) {
			activeSpaceLayer.visible = false;
		}

		const pullSpaceLayer: Container | null = application.layerManager.getLayer(
			LayerPaths.UI_TIMELINE_PULL_SPACE
		);
		if (pullSpaceLayer) {
			pullSpaceLayer.visible = false;
		}
	}
	/**
	 * Invoked once the export is finished. This turns the timeline back on.
	 * @param canvasAngularLand
	 * @param application
	 */
	public onExportComplete(canvasAngularLand: CanvasAngularLand, application: AbstractApplication): void {
		const timelineLayer: Container | null = application.layerManager.getLayer(LayerPaths.UI_TIMELINE_ROOT);
		if (timelineLayer) {
			timelineLayer.visible = true;
		}

		const activeSpaceLayer: Container | null = application.layerManager.getLayer(
			LayerPaths.UI_TIMELINE_ACTIVE_SPACE
		);
		if (activeSpaceLayer) {
			activeSpaceLayer.visible = true;
		}

		const pullSpaceLayer: Container | null = application.layerManager.getLayer(
			LayerPaths.UI_TIMELINE_PULL_SPACE
		);
		if (pullSpaceLayer) {
			pullSpaceLayer.visible = true;
		}
	}
}
